import type { Incident } from '@/lib/queries/rca/incidents';

import incidentIoLogo from '../../../integrations/-components/logos/incident-io.svg?url';
import pagerdutyLogo from '../../../integrations/-components/logos/pagerduty.svg?url';
import slackLogo from '../../../integrations/-components/logos/slack.svg?url';

type IncidentForResolution = {
  incidentNumber?: number;
  title: string;
  summary?: string;
  priority?: string; // TODO - Enum
  startedAt: string;
  resolvedAt?: string;
  sourceStatus: string; // TODO - Enum
};

export const getPrimaryIncidentData = (
  incident: Incident,
): IncidentForResolution | undefined => {
  if (incident.pagerDutyIncident) {
    return {
      incidentNumber: incident.pagerDutyIncident.incidentNumber,
      title: incident.pagerDutyIncident.title,
      summary: incident.pagerDutyIncident.summary,
      priority: incident.pagerDutyIncident.priority,
      startedAt: incident.pagerDutyIncident.startedAt,
      resolvedAt: incident.pagerDutyIncident.resolvedAt,
      sourceStatus: incident.pagerDutyIncident.status,
    };
  }

  // if (incident.incidentIoIncident) {
  //   return {
  //     incidentNumber: incident.incidentIoIncident.incidentNumber,
  //     title: incident.incidentIoIncident.title,
  //     summary: incident.incidentIoIncident.summary,
  //     status: incident.incidentIoIncident.status,
  //     priority: undefined,
  //     severity: incident.incidentIoIncident.severity,
  //     startedAt: incident.incidentIoIncident.startedAt,
  //     resolvedAt: incident.incidentIoIncident.resolvedAt,
  //   };
  // }

  if (incident.slackIncident) {
    return {
      incidentNumber: undefined,
      title: incident.slackIncident.messageText,
      summary: undefined,
      priority: undefined,
      startedAt: incident.slackIncident.createdAt,
      resolvedAt: undefined,
      sourceStatus: incident.slackIncident.status,
    };
  }

  console.error('No primary incident data found for incident', { incident });
};

export const getSourceIcon = (sourceType: string): string => {
  switch (sourceType) {
    case 'pagerduty':
      return pagerdutyLogo;
    case 'incident_io':
      return incidentIoLogo;
    case 'slack':
      return slackLogo;
    default:
      return pagerdutyLogo; // Default to PagerDuty logo if unknown source
  }
};

export const getSourceName = (sourceType: string): string => {
  switch (sourceType) {
    case 'pagerduty':
      return 'PagerDuty';
    case 'incident_io':
      return 'Incident.io';
    case 'slack':
      return 'Slack';
    default:
      return 'Unknown';
  }
};
